import type { MaybeRef } from 'vue';

export const firewallKeys = {
  all: ['firewalls'] as const,
  firewalls: (params?: MaybeRef<{ page: number; query?: string }>) =>
    [...firewallKeys.all, 'firewalls', ...(params ? [params] : [])] as const,
  firewall: (uuid: MaybeRef<string>) => [...firewallKeys.all, 'firewall', uuid] as const,
  attachedStacklets: (
    uuid: MaybeRef<string>,
    params?: MaybeRef<{ page: number; query?: string; has_firewall?: boolean }>,
  ) => [...firewallKeys.all, 'attached-stacklets', uuid, ...(params ? [params] : [])] as const,
};
